function Header({ title, className }: { title: string; className?: string }) {
  return (
    <div className={`text-[20px] font-semibold ${className}`}>{title}</div>
  );
}

export default Header;
